import { InputBase, Typography } from "@mui/material";
import React from "react";
import { Colors } from "../../Constants/colors";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";

interface Props {
  placeHolder: string;
  value: string | number;
  setValue: (value: string | number) => unknown;
  type?: "number" | "text" | "password" | "email" | "tel" | "url";
  disabled?: boolean;
  defaultValue?: any;
  label?: string;
  multiline?: boolean;
}

export const SearchInput = ({
  placeHolder,
  label,
  value,
  setValue,
  type = "text",
  disabled = false,
  defaultValue = null,
  multiline = false,
}: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;

    const actualValue = type === "number" ? Number(value) : value;

    setValue(actualValue);
  };

  const displayValue = type === "number" ? String(value) : value;

  return (
    <div style={{ width: "100%" }}>
      {label ? (
        <Typography
          style={{
            paddingLeft: "5px",
            fontSize: "14px",
          }}
        >
          {label}
        </Typography>
      ) : (
        <></>
      )}
      <InputBase
        className="rounded-sm"
        style={inputButtonStyle}
        placeholder={placeHolder}
        value={displayValue}
        onChange={handleChange}
        type={type}
        disabled={disabled}
        defaultValue={defaultValue}
        multiline
      />
    </div>
  );
};

const inputButtonStyle = {
  width: "100%",
  height: "auto",
  padding: "10px",
  border: `1px solid ${Colors.VeryLightGrey}`,
  fontFamily: FontFamily.ROBOTO_REGULAR,
  fontSize: "14px",
  color: Colors.DarkGrey,
  // backgroundColor: "rgba(247, 247, 247, 1)",
  backgroundColor: Colors.LightAshRose,
  borderRadius: "8px",
};
